var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.82947 1.63656C1.72535 1.58573 1.60833 1.56746 1.49366 1.58412C1.37899 1.60077 1.27201 1.6516 1.18665 1.72995C1.10129 1.80831 1.04153 1.91057 1.01515 2.0234C0.988762 2.13622 0.996986 2.25438 1.03874 2.36246L4.33017 11.1925C4.52429 11.7137 4.52429 12.2874 4.33017 12.8087L1.0399 21.6387C0.998354 21.7466 0.990237 21.8646 1.01661 21.9772C1.04298 22.0898 1.10261 22.1919 1.18777 22.2702C1.27292 22.3485 1.37965 22.3993 1.49409 22.4162C1.60853 22.433 1.72539 22.415 1.82947 22.3646L22.6686 12.5239C22.7677 12.477 22.8515 12.4029 22.9102 12.3103C22.9689 12.2176 23 12.1102 23 12.0006C23 11.8909 22.9689 11.7835 22.9102 11.6909C22.8515 11.5982 22.7677 11.5242 22.6686 11.4773L1.82947 1.63656Z",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.47656 12H23.0002",
    stroke: "#6C6859",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.97a4ba2df293e2c0791191260ddee43c.svg";
export { ForwardRef as ReactComponent };